/* eslint-disable */
// noinspection JSUnusedLocalSymbols

import Swiper from 'swiper';
import Mmenu from 'mmenu-js';
import '../../../node_modules/mmenu-js/dist/mmenu.css';

(function ($) {
  $(window).on('load', () => {
    $('.preloader').fadeOut(1000);
  });

  // $('.js-header-center').on('click', (event) => {
  //   console.log('evet');
  //   event.stopPropagation();
  //   $('.js-dropdown-menu').toggle();
  // });

  $(document).on('click', () => {
    $('.js-dropdown-menu').hide();
  });

  $(document).on('click', '.js-open-m-menu', () => {
    $('#js-sidebar-menu').toggleClass('d-none');
  });

  // lightcase
  $('a[data-rel^=lightcase]').lightcase();

  $(document).ready(() => {
    /*= === header Section Start here ===== */
    $('ul>li>.submenu').parent('li').addClass('menu-item-has-children');
    // drop down menu width overflow problem fix
    $('ul').parent('li').on('hover', function () {
      const menu = $(this).find('ul');
      const menupos = $(menu).offset();
      if (menupos.left + menu.width() > $(window).width()) {
        const newpos = -$(menu).width();
        menu.css({
                   left: newpos,
                 });
      }
    });
    $('.menu li a').on('click', function (e) {
      const element = $(this).parent('li');
      if (element.hasClass('open')) {
        element.removeClass('open');
        element.find('li').removeClass('open');
        element.find('ul').slideUp(300, 'swing');
      } else {
        element.addClass('open');
        element.children('ul').slideDown(300, 'swing');
        element.siblings('li').children('ul').slideUp(300, 'swing');
        element.siblings('li').removeClass('open');
        element.siblings('li').find('li').removeClass('open');
        element.siblings('li').find('ul').slideUp(300, 'swing');
      }
    });
    $('.ellepsis-bar').on('click', (e) => {
      const element = $('.header-top');
      if (element.hasClass('open')) {
        element.removeClass('open');
        element.slideUp(300, 'swing');
        $('.overlayTwo').removeClass('active');
      } else {
        element.addClass('open');
        element.slideDown(300, 'swing');
        $('.overlayTwo').addClass('active');
      }
    });
    $('.header-bar').on('click', function () {
      $(this).toggleClass('active');
      $('.menu').toggleClass('active');
    });

    // Header
    const fixed_top = $('header');
    $(window).on('scroll', function () {
      if ($(this).scrollTop() > 300) {
        fixed_top.addClass('header-fixed fadeInUp');
      } else {
        fixed_top.removeClass('header-fixed fadeInUp');
      }
    });

    /*= === header Section End here ===== */

    // scroll up start here
    $(() => {
      $(window).on('scroll', function () {
        if ($(this).scrollTop() > 300) {
          $('.scrollToTop').css({
                                  bottom: '5%',
                                  opacity: '1',
                                  transition: 'all .5s ease',
                                });
        } else {
          $('.scrollToTop').css({
                                  bottom: '-30%',
                                  opacity: '0',
                                  transition: 'all .5s ease',
                                });
        }
      });

      // Click event to scroll to top
      $('a.scrollToTop').on('click', () => {
        $('html, body').animate({
                                  scrollTop: 0,
                                }, 500);
        return false;
      });
    });

    // wow animation
    // new WOW().init();


    //= ===Player slider================
    var swiper = new Swiper('.player-slider', {
      slidesPerView: 5,
      spaceBetween: 20,
      loop: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      breakpoints: {
        575: {
          slidesPerView: 1,
          spaceBetween: 10,
        },

        767: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        1199: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        1439: {
          slidesPerView: 4,
          spaceBetween: 20,
        },
      },
    });


    //= ===testimonial slider================
    var swiper = new Swiper('.testimonial-slider', {
      slidesPerView: 2,
      spaceBetween: 20,
      loop: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      breakpoints: {
        767: {
          slidesPerView: 1,
        },
      },
    });

    $(window).on('load', () => {
      // collection isotope js
      // init Isotope
      // const $grid = $('.collection-grid').isotope({
      //   itemSelector: '.gameListItem',
      //   layoutMode: 'fitRows',
      // });

      // filter functions
      // const filterFns = {
      //   // show if number is greater than 50
      //   numberGreaterThan50() {
      //     const number = $(this).find('.number').text();
      //     return parseInt(number, 10) > 50;
      //   },
      // };

      // // bind filter button click
      // $('.collection-filter-button-group').on('click', 'li', function () {
      //   let filterValue = $(this).attr('data-filter');
      //   // use filterFn if matches value
      //   filterValue = filterFns[filterValue] || filterValue;
      //   $grid.isotope({ filter: filterValue });
      // });


      // change is-checked class on buttons
      $('.collection-filter-button-group').each((i, buttonGroup) => {
        const $buttonGroup = $(buttonGroup);
        $buttonGroup.on('click', 'li', function () {
          $buttonGroup.find('.is-checked').removeClass('is-checked');
          $(this).addClass('is-checked');
        });
      });
    });

    $(window).on('load', () => {
      // match isotope js
      // init Isotope
      // const $grid = $('.match-grid').isotope({
      //   itemSelector: '.matchlistitem',
      //   layoutMode: 'fitRows',
      // });

      // filter functions
      // const filterFns = {
      //   // show if number is greater than 50
      //   numberGreaterThan50() {
      //     const number = $(this).find('.number').text();
      //     return parseInt(number, 10) > 50;
      //   },
      // };

      // bind filter button click
      // $('.match-filter-button-group').on('click', 'li', function () {
      //   let filterValue = $(this).attr('data-filter');
      //   // use filterFn if matches value
      //   filterValue = filterFns[filterValue] || filterValue;
      //   $grid.isotope({ filter: filterValue });
      // });


      // change is-checked class on buttons
      $('.match-filter-button-group').each((i, buttonGroup) => {
        const $buttonGroup = $(buttonGroup);
        $buttonGroup.on('click', 'li', function () {
          $buttonGroup.find('.is-checked').removeClass('is-checked');
          $(this).addClass('is-checked');
        });
      });
    });


    // Gallery Masonary
    $(window).on('load', () => {
      // init Isotope
      // const $grid = $('.masonary-gallery').isotope({
      //   itemSelector: '.masonary-item',
      //   // layoutMode: 'fitRows',
      //   masonry: {
      //     columnWidth: 0,
      //   },
      // });

      // filter functions
      // const filterFns = {
      //   // show if number is greater than 50
      //   numberGreaterThan50() {
      //     const number = $(this).find('.number').text();
      //     return parseInt(number, 10) > 50;
      //   },
      // };

      // bind filter button click
      // $('.gallery-filter').on('click', 'li', function () {
      //   let filterValue = $(this).attr('data-filter');
      //   // use filterFn if matches value
      //   filterValue = filterFns[filterValue] || filterValue;
      //   $grid.isotope({ filter: filterValue });
      // });


      // change is-checked class on buttons
      $('.gallery-filter').each((i, buttonGroup) => {
        const $buttonGroup = $(buttonGroup);
        $buttonGroup.on('click', 'li', function () {
          $buttonGroup.find('.is-checked').removeClass('is-checked');
          $(this).addClass('is-checked');
        });
      });
    });


    // post thumb slider
    var swiper = new Swiper('.post-thumb-container', {
      slidesPerView: 1,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      navigation: {
        nextEl: '.thumb-next',
        prevEl: '.thumb-prev',
      },
      loop: true,
    });


    // shop cart + - start here
    const CartPlusMinus = $('.cart-plus-minus');
    $('.qtybutton').on('click', function () {
      const $button = $(this);
      const oldValue = $button.parent().find('input').val();
      if ($button.text() === '+') {
        var newVal = parseFloat(oldValue) + 1;
      } else if (oldValue > 0) {
        var newVal = parseFloat(oldValue) - 1;
      } else {
        newVal = 1;
      }
      $button.parent().find('input').val(newVal);
    });


    // shop sidebar menu
    $('#newsletter-form').on('submit', function (e) {
      e.preventDefault();

      $.post('/newsletter/save', $(this).serialize(), (response) => {
        // Swal(response.message, response.success ? 'success' : 'error');
        // window.alert("Your subscription to newsletter completed.");
        // $("#newsletter-alert").css("display", "block");

        Swal.fire(
          _t(response.success),
          _t(response.message),
          'success',
        );
      });
    });
    $('.shop-menu>li>ul').parent('li').addClass('catmenu-item-has-children');
    $('.shop-menu li a').on('click', function (e) {
      const element = $(this).parent('li');
      if (element.hasClass('open')) {
        element.removeClass('open');
        element.find('li').removeClass('open');
        element.find('ul').slideUp(300, 'swing');
      } else {
        element.addClass('open');
        element.children('ul').slideDown(300, 'swing');
        element.siblings('li').children('ul').slideUp(300, 'swing');
        element.siblings('li').removeClass('open');
        element.siblings('li').find('li').removeClass('open');
        element.siblings('li').find('ul').slideUp(300, 'swing');
      }
    });

    // product view mode change js
    $(() => {
      $('.product-view-mode').on('click', 'a', function (e) {
        e.preventDefault();
        const shopProductWrap = $('.shop-product-wrap');
        const viewMode = $(this).data('target');
        $('.product-view-mode a').removeClass('active');
        $(this).addClass('active');
        shopProductWrap.removeClass('grid list').addClass(viewMode);
      });
    });

    // model option start here
    $(() => {
      $('.view-modal').on('click', () => {
        $('.modal').addClass('show');
      });
      $('.close').on('click', () => {
        $('.modal').removeClass('show');
      });
    });
    // product single thumb slider
    $(() => {
      const galleryThumbs = new Swiper('.pro-single-thumbs', {
        spaceBetween: 10,
        slidesPerView: 3,
        loop: true,
        freeMode: true,
        loopedSlides: 1,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        navigation: {
          nextEl: '.pro-single-next',
          prevEl: '.pro-single-prev',
        },
      });
      const galleryTop = new Swiper('.pro-single-top', {
        spaceBetween: 10,
        loop: true,
        loopedSlides: 1,
        thumbs: {
          swiper: galleryThumbs,
        },
      });
    });

    // Review Tabs
    $('ul.review-nav').on('click', 'li', function (e) {
      e.preventDefault();
      const reviewContent = $('.review-content');
      const viewRev = $(this).data('target');
      $('ul.review-nav li').removeClass('active');
      $(this).addClass('active');
      reviewContent.removeClass('review-content-show description-show').addClass(viewRev);
    });
  });

  // contact form js
  $(() => {
    // Get the form.
    const form = $('#contact-form');
    // Get the messages div.
    const formMessages = $('.form-message');
    // Set up an event listener for the contact form.
    $(form).submit((e) => {
      // Stop the browser from submitting the form.
      e.preventDefault();
      // Serialize the form data.
      const formData = $(form).serialize();
      // Submit the form using AJAX.
      $.ajax({
               type: 'POST',
               url: $(form).attr('action'),
               data: formData,
             })
       .done((response) => {
         // Make sure that the formMessages div has the 'success' class.
         $(formMessages).removeClass('error');
         $(formMessages).addClass('success');
         // Set the message text.
         $(formMessages).text(response);
         // Clear the form.
         $('#contact-form input, #contact-form textarea').val('');
       })
       .fail((data) => {
         // Make sure that the formMessages div has the 'error' class.
         $(formMessages).removeClass('success');
         $(formMessages).addClass('error');
         // Set the message text.
         if (data.responseText !== '') {
           $(formMessages).text(data.responseText);
         } else {
           $(formMessages).text('Oops! An error occured and your message could not be sent.');
         }
       });
    });
  });


  document.addEventListener(
    "DOMContentLoaded", () => {
      if ($('#mmenu').length) {
        new Mmenu( "#mmenu", {
          "slidingSubmenus": false
        });
      }
    }
  );
}(jQuery));
